import { useReadableEventRefresher } from '@zdrbm/zdr-react';
import { useExplore } from './use-explore';

export function useExplorePoiState() {
    const explore = useExplore();

    const [[highlightedPoiId], [selectedPoiId]] = useReadableEventRefresher(
        explore.highlightedPoiId,
        explore.selectedPoiId,
    );

    return { highlightedPoiId, selectedPoiId };
}
